<script setup lang="ts">
import { Palette } from 'lucide-vue-next'

const { t } = useI18n()
</script>

<template>
  <span
    data-test-id="megamenu-personalize-badge"
    class="inline-flex items-center gap-1 bg-lime-200 text-lime-900 text-xs font-semibold px-3 py-1 rounded-full shrink-0"
  >
    <Palette class="h-3.5 w-3.5 shrink-0" />
    {{ t('megamenu.personalizeBadge') }}
  </span>
</template>
